var _defs, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWholesale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.79 15.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1e3f76;opacity:0.5;}.cls-2{fill:#141c31;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 7.89,
    cy: 7.89,
    r: 7.89
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.59,13.11a2.34,2.34,0,0,1,.74.37l2.4-.8a.23.23,0,0,0,.14-.3L15,9.69a.24.24,0,0,0-.3-.15l-.91.3.49,1.48-.9.3-.49-1.48-.91.31a.23.23,0,0,0-.15.3Zm4.16.48a.47.47,0,0,0-.6-.3l-3,1a1.42,1.42,0,0,0-1.09-.55l-1.37-4.1A1,1,0,0,0,9.78,9H8.7a.48.48,0,0,0,0,.95H9.79l1.36,4.11A1.42,1.42,0,0,0,12,16.59a1.43,1.43,0,0,0,1.42-1.4l3-1A.48.48,0,0,0,16.75,13.59ZM12,15.64a.48.48,0,0,1-.48-.48A.47.47,0,0,1,12,14.7a.46.46,0,0,1,.47.46A.47.47,0,0,1,12,15.64Z",
    transform: "translate(-4.64 -4.61)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWholesale);
export default __webpack_public_path__ + "static/media/wholesale.c7aba5cfd5790935fb5e6ce26fa96061.svg";
export { ForwardRef as ReactComponent };